module.exports = __webpack_public_path__ + "img/visa.24cbf0ba.svg";